import { useState, useMemo } from "react";
import { Box, Slider, Grid, Button } from "@mui/material";
import QuestionModel from "../Models/Survey/Questions/QuestionModel";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import SurveyService from "../Services/SurveyService";

export default function SliderAnswer(props: {
  questionModel: QuestionModel;
  surveyId: string;
  setQuestionModel: Function;
  setIsFirstQuestion: Function;
  setCurrentQuestionId: Function;
  setLoading: Function;
}) {
  const { t, i18n } = useTranslation("survey");

  const surveyService = useMemo(() => new SurveyService(), []);
  const [sliderValue, setSliderValue] = useState<number>(1);
  const marks = [];
  console.log(props.questionModel);
  for (
    var i = 0;
    i <= (props.questionModel.upperLimit ?? 10);
    i = i + (props.questionModel.step ?? 1)
  ) {
    marks.push({
      value: i,
      label: i.toString(),
    });
  }

  if (props.questionModel !== undefined) {
    return (
      <>
        <Box sx={{ width: "100%", maxWidth: 600 }}>
          <Slider
            defaultValue={props.questionModel.lowerLimit ?? 1}
            step={props.questionModel.step ?? 1}
            min={props.questionModel.lowerLimit ?? 1}
            max={props.questionModel.upperLimit ?? 10}
            valueLabelDisplay="auto"
            onChange={(e, newValue) => setSliderValue(newValue as number)}
            marks={marks}
          />
        </Box>

        <Grid justifyContent="center" container p={3}>
          <Button
            className="float-start"
            variant="contained"
            key={props.questionModel.id}
            style={{
              textTransform: "none",
              maxWidth: "100%",
            }}
            onClick={() => clickAnswer()}
          >
            {t("Volgende vraag")}
          </Button>
        </Grid>

        {props.questionModel.imageBase64String && (
          <img
            src={`data:${props.questionModel.imageType};base64,${props.questionModel.imageBase64String}`}
            alt="Vraag afbeelding"
            style={{
              marginTop: "1rem",
              maxWidth: "100%",
              maxHeight: "350px",
              height: "auto",
              display: "block",
            }}
          />
        )}
      </>
    );
  }

  return <></>;

  function clickAnswer() {
    if (props.questionModel) {
      props.setLoading(true);

      surveyService
        .saveAnswer(
          {
            surveyId: props.surveyId,
            questionId: props.questionModel.id,
            answer: sliderValue?.toString() ?? null,
            nextQuestionId: null,
            possibleAnswerId: null,
          },
          i18n.language,
        )
        .then((result) => {
          if (result) {
            if (result.success) {
              //do stuff with question
              if (result.nextQuestionModel !== null) {
                //set Progress bar
                props.setQuestionModel(result.nextQuestionModel);
                props.setIsFirstQuestion(
                  result.nextQuestionModel.thisIsTheFirstQuestion,
                );
                props.setCurrentQuestionId(result.nextQuestionModel.id);
              }
            } else {
              toast.error(t("Fout bij opslaan van vraag."));
            }
          }
          props.setLoading(false);
        });
    }
  }
}
